import createHamletClient, { HamletError } from './createHamletClient';

export { HamletError };

const client = createHamletClient();

export default client;
